import { render, staticRenderFns } from "./activity-detail.vue?vue&type=template&id=64cd1e28&scoped=true&"
import script from "./activity-detail.vue?vue&type=script&lang=js&"
export * from "./activity-detail.vue?vue&type=script&lang=js&"
import style0 from "./activity-detail.vue?vue&type=style&index=0&id=64cd1e28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd1e28",
  null
  
)

export default component.exports